<template>
  <div class="list-box">
    <!-- 草稿报告 -->
    <template v-if="showDemoReport">
      <el-row type="flex" justify="space-between" align="middle">
        <strong class="text-dark pdc">草稿报告</strong>
      </el-row>
      <el-table border :data="localDemoList" size="mini">
        <el-table-column prop="name" label="名称" width="120">
          <template slot-scope="scope">
            <strong>{{ scope.row.name }}</strong>
          </template>
        </el-table-column>
        <el-table-column prop="ReportNo" label="报告编号" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.ReportNo || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="DemoReportUpTime" label="上传时间" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.DemoReportUpTime || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="DemoReporStatus" label="确认状态" width="70" align="center">
          <template slot-scope="scope">
            <span>{{ getDemoReportStatusText(scope.row.DemoReporStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="DemoReporRemark" label="反馈信息" min-width="120" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.DemoReporRemark || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="QRTime" label="确认时间" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.QRTime || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="url" label="操作" width="280" align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                v-if="scope.row.url.toUpperCase().endsWith('.PDF')"
                @click="onReviewReport(scope.row.url)"
                size="mini"
                icon="el-icon-view"
                >预览</el-button
              >
              <el-button
                @click="onDownloadReport(scope.row)"
                size="mini"
                type="primary"
                icon="el-icon-download"
                >下载</el-button
              >
              <el-button
                v-if="!hidebtn && scope.row.DemoReporStatus === 0"
                @click="OnDemoReportConfirm(scope.row)"
                size="mini"
                type="danger"
                icon="el-icon-s-check"
                >草报告确认</el-button
              >
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <!-- 正式报告 -->
    <template v-if="showOfficialReport">
      <el-row type="flex" justify="space-between" align="middle">
        <strong class="text-success pdc">正式报告</strong>
      </el-row>
      <el-table border :data="localOfficialList" size="mini">
        <el-table-column prop="name" label="名称" min-width="200">
          <template slot-scope="scope">
            <strong>{{ scope.row.name }}</strong>
          </template>
        </el-table-column>
        <el-table-column prop="url" label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                v-if="scope.row.url.toUpperCase().endsWith('.PDF')"
                @click="onReviewReport(scope.row.url)"
                size="mini"
                icon="el-icon-view"
                >预览</el-button
              >
              <el-button
                @click="onDownloadReport(scope.row)"
                size="mini"
                type="primary"
                icon="el-icon-download"
                >下载</el-button
              >
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <!-- 草报告确认弹窗 -->
    <el-dialog
      title="草报告确认"
      :visible.sync="demoReportConfirmDialogVisible"
      width="500px"
      center
      append-to-body
      destroy-on-close
    >
      <el-form>
        <el-radio-group v-model="demoReportStatus" style="margin-bottom: 20px;">
          <el-radio :label="1">确认</el-radio>
          <el-radio :label="-1">反馈</el-radio>
        </el-radio-group>
        <el-input
          v-model="demoReportRemark"
          type="textarea"
          :rows="4"
          placeholder="请输入反馈信息"
          :disabled="demoReportStatus === 1"
        />
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="demoReportConfirmDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onDemoReportConfirmSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { saveAs } from 'file-saver';
import gApi, { GetOrderInfo } from '@/api/general-api'

export default {
  name: 'ReportList',
  props: {
    id: {
      type: String,
      default: () => null
    },
    demolist: {
      type: Array,
      default: () => []
    },
    officiallist: {
      type: Array,
      default: () => []
    },
    hidebtn: {
      type: Boolean,
      default: () => false
    }
  },
  data(){
    return {
      hide:false,
      localDemoList: [],
      localOfficialList: [],
      // 草报告确认弹窗
      demoReportConfirmDialogVisible: false,
      demoReportStatus: 1,
      demoReportRemark: '',
      currentDemoReportRow: null,
    }
  },
  watch: {
    demolist: {
      handler(val) {
        this.localDemoList = Array.isArray(val) ? [...val] : []
      },
      immediate: true
    },
    officiallist: {
      handler(val) {
        this.localOfficialList = Array.isArray(val) ? [...val] : []
      },
      immediate: true
    }
  },
  computed: {
    showDemoReport() {
      return Array.isArray(this.localDemoList) && this.localDemoList.length > 0 && !this.hidebtn
    },
    showOfficialReport() {
      return Array.isArray(this.localOfficialList) && this.localOfficialList.length > 0 && this.hidebtn
    }
  },
  mounted(){
    this.hide = this.hidebtn
  },
  methods: {
    getDemoReportStatusText(status) {
      const statusMap = {
        '-1': '未确认',
        '0': '待确认',
        '1': '已确认'
      }
      return statusMap[status] || statusMap[status.toString()] || '-'
    },
    onReviewReport(url) {
      const a = document.createElement('a')
      a.href = url
      a.target = "_blank";
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    onDownloadReport({ url, name }) {
      if (url.toUpperCase().endsWith('.PDF')) {
        const oReq = new XMLHttpRequest();
        oReq.open("GET", url, true);
        oReq.responseType = "blob";
        oReq.onload = function () {
          var file = new Blob([oReq.response], {
            type: 'application/pdf'
          });

          saveAs(file, name.toLowerCase().includes(".pdf") ? name : name + ".pdf");
        }

        oReq.send();

      } else {
        const a = document.createElement('a');
        a.href = url;
        a.target = "_blank";
        a.download = url
        a.click();
      }
    },
    OnDemoReportConfirm(row) {
      this.currentDemoReportRow = row
      this.demoReportStatus = 1
      this.demoReportRemark = ''
      this.demoReportConfirmDialogVisible = true
    },
    /** 提交草报告确认 */
    onDemoReportConfirmSubmit() {
      if (this.demoReportStatus === -1 && !this.demoReportRemark.trim()) {
        return this.$message.warning('请输入反馈信息')
      }

      const postData = {
        ID: this.currentDemoReportRow ? this.currentDemoReportRow.ID : this.id,
        data: JSON.stringify({
          DemoReporStatus: this.demoReportStatus,
          DemoReporRemark: this.demoReportRemark.trim()
        })
      }

      gApi.DemoReporConfirm(postData).then(res => {
        if (!res.success) {
          return this.$message.error('提交失败：' + res.msg)
        }
        this.$message.success(this.demoReportStatus === 1 ? '确认成功' : '反馈成功')
        this.refreshReportList()
        this.demoReportConfirmDialogVisible = false
        this.currentDemoReportRow = null
        this.$emit('confirm-success')
      }).catch(() => {
        this.$message.error('提交失败')
      })
    },
    /** 刷新报告列表数据 */
    refreshReportList() {
      if (!this.id) return
      GetOrderInfo(this.id, false).then(res => {
        if (!res.success || !res.data) return
        this.localDemoList = Array.isArray(res.data.DemoReport) ? res.data.DemoReport : []
        this.localOfficialList = Array.isArray(res.data.OfficialReport) ? res.data.OfficialReport : []
      }).catch(() => {})
    },
    OnTempReprotPass() {
      gApi.TempReprotPass({
        ID: this.id,
        Data: JSON.stringify({})
      }).then(res => {
        if (!res.success) {
          return this.$message.error("操作失败：" + res.msg)
        } else {
          this.hide = true
          return this.$message.success("操作成功！")
          
        }
      })
    },
    OnTempReprotNoPass() {
      this.$prompt('请输入拒绝的原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.+/,
        inputErrorMessage: '请输入拒绝的原因',
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(({ value }) => {
        gApi.TempReprotNoPass({
          ID: this.id,
          Data: JSON.stringify({
            ErrorType: "草稿报告被拒绝",
            ErrorRemark: value
          })
        }).then(res => {
          if (!res.success) {
            return this.$message.error("操作失败：" + res.msg)
          } else {
            return this.$message.success("操作成功！")
          }
        })
      }).catch(() => { });
    }
  }
}
</script>

<style lang="scss">
.list-box {
  padding: 0px;
  .el-descriptions-item__cell {
    padding: 0px 5px !important;
  }
}
</style>